// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"851":"355ec8ee","882":"2305f1a7"}[chunkId] + ".chunk.css";
};